<!--头部搜索-->
<template>
  <div class="search-header">
    <van-icon v-if="showBack" name="arrow-left" @click="goBack" size="22" color="#6f6f6f" />
    <searchInput placeholder="搜索商品" :input.sync="goodsName" @keypress="keypressSearch" ref="searchInput"></searchInput>
    <self-button type="default" no-min-width @on-click="searchGoods">搜索</self-button>
  </div>
</template>

<script>
import searchInput from 'components/search-input';
import selfButton from 'components/self-button';
export default {
  components: {
    searchInput,
    selfButton
  },
  props: {
    from:{//哪个页面使用的，用户搜索商品后返回到这个页面
      type:String,
      default:''
    },
    showBack: { //是否需要返回按钮
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      goodsName: '',
    };
  },
  methods: {
    //返回
    goBack() {
      this.$emit('goback');
      this.$refs.searchInput.clearName();
      // console.log(this.$refs.searchInput);
    },
    getInput(data) {
      this.goodsName = data;
    },
    searchGoods(){
      if (!this.goodsName) return
      this.$emit('search-goods',this.goodsName)
      const query = {
        goodsName: this.goodsName,
        from: this.from
      }
      this.$router.push({
        path:'/goods-list',
        query
      })
    },
    keypressSearch(e) {
      if(e.keyCode === 13) {
        this.searchGoods()
      }
    }
  },
};
</script>

<style scoped lang="scss">
@import 'common/sass/theme.scss';
.search-header {
  display: flex;
  align-items: center;
  height: $header-search;
  padding: 0 10px;
  line-height: $header-search;
  box-sizing: border-box;
  border-bottom: 1px solid $light-line-color;
  justify-content: space-around;
  .search-icon {
    min-width: 50px;
    height: 29px;
    padding: 0 8px;
    line-height: 25px;
    border-radius: 5px;
  }
}
</style>
